import { createApp } from "vue";
import Dialog from "./Dialog";

export enum ShowModalIcon {
    STOP = 'stop',
}

interface ShowModalOptions {
    icon?: ShowModalIcon;

    title?: string;
    header?: string;
    message?: string;

    label_ok?: string;

    visible_ok?: boolean;

    class?: string;
}

export default class Dialogs {
    public static async showModal(options: ShowModalOptions): Promise<boolean> {
        return new Promise((res, err) => {
            const $el = $('<div>');
            $el.appendTo($('body'));

            const app = createApp({
                components: {
                    Dialog,
                },

                template: `
                    <Dialog
                        ref="dialog"

                        :title="options.title"
                        :header="options.header"
                        :icon="options.icon"

                        @close="onClose"
                        @ok="onOk"
                    >
                        <div v-if="options.message" v-html="options.message"></div>
                    </Dialog>
                `,

                data() {
                    return {
                        options: options,
                    };
                },

                mounted() {
                    this.$refs.dialog.show();
                },

                methods: {
                    onClose() {
                        app.unmount();
                        $el.remove();

                        res(null);
                    },

                    onOk() {
                        res(true);
                    },
                },
            });

            app.mount($el[0]);
        });
    }
}
